module.exports = __webpack_public_path__ + "media/images/icon_list/circle_add-e198267d98ec3c062ea7dc2c76de7bea.svg";